<template>
    <div>
        <van-list style="margin-bottom: 10px;">
			<div v-for="(item, index) in orderDetail.detail.exchange_goods" :key="index">
				<van-card  :num="item.buy_number" :thumb="item.image" style="background-color: #ffffff;">
					<template #price>
						<div style="theme-text-color">
							<div class="goods-inline" v-if="item.integral > 0">{{item.integral}}<span>积分</span></div>
							<div class="goods-inline" v-if="item.integral > 0 && item.amount > 0">+</div>
							<div class="goods-inline" v-if="item.amount > 0">{{item.amount}}<span>元</span></div>
						</div>
					</template>
					<template #title>
						<div style="font-size: 18px;">{{item.title}}</div>
					</template>
				</van-card>
			</div>
        </van-list>
			<van-cell
				title="选择站点"
				:value="this.siteName"
				is-link
				v-if="sites.length > 0"
				@click="showSiteList = true">
			</van-cell>
        <van-cell
            title="会员积分兑换"
            :label="`${userIntegral} 积分`"
            v-if="!(userIntegral === '')">
            <template #right-icon>
                <van-switch v-model="isUseIntegral" size="24" inactive-color="#ee2464" active-color="green" :disabled="userIntegral <= 0"/>
            </template>
        </van-cell>
        <van-cell icon="debit-pay"
                  :title="selectCardNo"
                  :value="selectCardSumIntegral + ' 积分'"
                  label="点击使用油卡(可选多张卡)"
                  is-link
                  @click="showCard = true"/>

        <van-submit-bar
			:loading="isLoading"
			:decimal-length="0"
			currency=""
			label=""
			suffix-label=""
			button-text="确认兑换"
			:disabled="(isUseIntegral ? selectCardSumIntegral + userIntegral : selectCardSumIntegral) < orderDetail.total_integral" @submit="exchange"
		>
			<template>
				<div class="price">
					合计:
					<span class="number" style="padding-left: 5px;" v-if="orderDetail.total_amount > 0">{{orderDetail.total_amount}}<span class="unit">元</span></span>
					<span class="number" v-if="orderDetail.total_amount > 0 && orderDetail.total_integral > 0">+</span>
					<span class="number" v-if="orderDetail.total_integral > 0">{{orderDetail.total_integral}}<span class="unit">积分</span></span>
				</div>

			</template>
		</van-submit-bar>
        <van-popup v-model="showCard" position="bottom" round>
            <div class="popup_tit">
                <span>选择油卡</span>
                <van-button type="info" size="small" @click="showCard = false" round class="color-button">确 定</van-button>
            </div>

            <div class="card-list">
                <div :class="{ 'card-item' : true, 'active' : isSelectCardIndex(index)}" v-for="(item, index) in cardList" :key="index" @click="selectCard(index)">
                    <card-design :card-info="item"></card-design>
                    <van-icon name="success" color="#ffffff" size="20"/>
                </div>
            </div>
        </van-popup>

		<van-popup v-model="showSiteList" round position="bottom">
			<van-picker show-toolbar :columns="siteNameList" @cancel="showSiteList = false" @confirm="setSite"/>
		</van-popup>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import CardDesign from "../../components/beilin/CardDesign";
    import common from '../../assets/js/common'


    export default {
        name: "Checkout",
        components : {
            CardDesign,
        },
        data(){
            return {
                isLoading: false,
                showCard : false,
                cardList : [],
                selectCardIndex : [],
                orderDetail : {
                    detail : {},
                },
				sites: [],
                userIntegral: 0,
                isUseIntegral: false,
				site: '',
				siteName: '',
				showSiteList: false,
            };
        },
        computed : {
            selectCardData(){
                let data = [];
                for (let i = 0; i < this.selectCardIndex.length; i++){
                    data.push(this.cardList[parseInt(this.selectCardIndex[i])]);
                }
                return data;
            },
            selectCardNo(){
                let cardNo = '';
                if(this.selectCardData.length > 0){
                    cardNo = 'No.' + this.selectCardData[0]['card_no'] + (this.selectCardData.length > 1 ? '...' : '');
                }
                return cardNo;
            },
            selectCardSumIntegral(){
                let sumIntegral = 0;
                for (let i = 0; i < this.selectCardData.length; i++){
                    sumIntegral += this.selectCardData[i]['integral'];
                }
                return sumIntegral;
            },
			siteNameList() {
				return this.sites.map(item => item.name)
			}
        },
        created() {
            let self = this;
            api.request('/user_card/list').then(res => {
                self.cardList = res.data;
                let cardIndexArr = {};
                for(let index in res.data){
                    cardIndexArr[res.data[index]['id']] = index;
                    if(res.data[index]['is_default'] === true){
                        self.selectCardIndex = [index];
                    }
                }
            });
            this.refresh();
        },
        methods : {
            refresh(){
                let self = this;
                api.request('/integral_goods/checkout', {
                    exchange_data : [
                        {
                            goods_id : this.$route.query.goodsId,
                            number : this.$route.query.number,
                        },
                    ],
                }).then(res => {
                    self.orderDetail = res.data.order_detail;
					self.sites = res.data.suit_site;
                    if (self.userIntegral !== undefined) {
                        self.userIntegral = res.data.user_integral;
                    }
                });
            },
            exchange(){
                if (this.isLoading) return;
				if (!this.site) {
					this.$notify({ type: 'danger', message: '请选择站点后再进行兑换' })
					return
				}
                let self = this;
                let use_user_card_id = [];
                for (let i = 0; i < this.selectCardData.length; i++){
                    use_user_card_id.push(this.selectCardData[i]['id']);
                }
                this.isLoading = true
                api.request('/integral_goods/exchange', {
                    exchange_data : [
                        {
                            goods_id : this.$route.query.goodsId,
                            number : this.$route.query.number,
                        },
                    ],
                    use_user_integral : this.isUseIntegral,
                    use_user_card_id : use_user_card_id,
					site_id: this.site || ''
                }).then(res => {
                    if(res.data.payment_info){
                        let paymentInfo = JSON.parse(res.data.payment_info);
                        let orderData = res.data.user_integral_order;
                        common.wechatPayReady(paymentInfo.appId, () => {
                            wx.chooseWXPay({
                                timestamp: paymentInfo.timeStamp,
                                nonceStr: paymentInfo.nonceStr,
                                package: paymentInfo.package,
                                signType: paymentInfo.signType,
                                paySign: paymentInfo.paySign,
                                success(res) {
                                    self.$toast({
                                        message : '兑换成功',
                                        onClose(){
											self.$router.push({
												name : 'IntegralOrderDetail',
												query : {
													orderNo : orderData.order_no,
												},
											})
                                        },
                                    });
                                },
                                cancel(res) {
									self.$router.push({
										name : 'IntegralOrderDetail',
										query : {
											orderNo : orderData.order_no,
										},
									})
                                },
                                fail(res){
                                    self.$toast(res.errMsg);
                                },
                            });
                        });
                    } else {
						self.$toast.success(res.msg);
						self.$router.push({
							name : 'IntegralOrderDetail',
							query : {
								orderNo : res.data.user_integral_order.order_no,
							},
						})
					}
                }).catch(res => {
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.isLoading = false
                });
            },
            isSelectCardIndex(index){
                return this.selectCardIndex.indexOf(index.toString()) !== -1;
            },
            selectCard(index){
                let cardIndex = this.selectCardIndex.indexOf(index.toString());
                if(cardIndex !== -1){
                    this.selectCardIndex.splice(cardIndex, 1);
                }else{
                    this.selectCardIndex.push(index.toString());
                }
            },
			setSite(val, key) {
				this.site = this.sites.filter(item => item.name === val)[0].id;
				this.siteName = val;
				this.showSiteList = false;
			}
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .theme-text-color {
                color: themed('colorText')
            }

            /deep/ .van-submit-bar {
                .van-submit-bar__price {
                    color: themed('colorText')
                }

                .van-submit-bar__button--danger {
                    color: #FFF;
                    background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
                }
            }

			.price {
				flex: 1;
				padding: 0 10px;
				font-size: 14px;
				color: #333;

				.number {
					color: rgb(243, 9, 75);
					font-size: 16px;

					.unit {
						font-size: 12px;
					}
				}
			}

			.goods-inline {
				display: inline-block;
			}

			.popup_tit {
				.color-button {
					font-size: 14px;
					width: 2rem;
					border: none;
                    color: #FFF;
                    background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
				}
			}

			.card-list{
				overflow-y: auto;
				padding-top: 20px;
				height: 80vh;

				.card-item{
					width: 290px;
					margin: auto auto 20px;
					position: relative;
					border-radius: 15px;
					overflow: hidden;
					border: 3px solid transparent;
					box-sizing: border-box;

					i {
						position: absolute;
						bottom: 0;
						right: 0;
						width: 0;
						height: 0;
						border-top: transparent solid 20px;
						border-left: transparent solid 20px;
						border-bottom: themed('colorText') solid 20px;
						border-right: themed('colorText') solid 20px;
						display: none;
					}

					i:before {
						position: absolute;
						right: -18px;
						bottom: -18px;
						display: block;
						transform: rotate(-30deg);
					}

					&.active{
						border: 3px solid themed('colorText');
						i{
							display: block;
						}
					}
				}
			}
        }
    }


</style>



// WEBPACK FOOTER //
// src/pages/goods/Checkout.vue